import AppConstants from '../config/app.constants';

let BagoutService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/bagout`, {
                params: {
                    "search": search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let closeBagout = (bagoutId, branchId, routeId, date, carrierId, carrierName, supervisorId, shipmentData) => {
        return $http
            .post(AppConstants.api + `/bagout/${bagoutId}/close`, {
                branchId,
                routeId,
                date,
                carrierId, 
                carrierName,
                supervisorId, 
                shipmentData
            })
            .then((res) => {
                return res.data
            })
    };

    let getShipments = (bagoutId) => {
        return $http
            .get(AppConstants.api + `/bagout/${bagoutId}/shipments`)
            .then((res) => {
                return res.data
            })
    };

    let getBagsealData = (bagSeal) => {
        return $http
            .get(AppConstants.api + `/bagout/bagseal-data`, {
                params: {
                    bagSeal
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let undoBagout = (bagSealId, branchId) => {
        return $http
            .post(AppConstants.api + `/bagout/undo-bagout`, {
                bagSealId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let getDeliveryRoutes = (id, date) => {
        return $http
            .get(AppConstants.api + `/bagout/${id}/delivery-date-routes?date=${date}`)
            .then((res) => {
                return res.data;
            })
    };

    let getBagoutData = (searchText, startDate, endDate, customerId, offset, limit) => {
        return $http
            .post(AppConstants.api + `/bagout/bagout-history`, {
                searchText, 
                startDate, 
                endDate,
                customerId,
                offset, 
                limit 
            })
            .then((res) => {
                return res.data
            })
    }

    let exportBagoutHistory = (searchText, startDate, endDate, offset, limit) => {
        return $http
            .post(AppConstants.api + `/bagout/export-bagout-history`, {
                searchText,
                startDate,
                endDate,
                offset,
                limit
            })
            .then((res) => {
                return res.data;
            })
    }

    let getRemainingBagoutCount = (branchId, destinationLocationId) => {
        return $http
            .get(AppConstants.api + `/bagout/get-remaining-bagout-count`, {
                params: {
                    branchId, 
                    destinationLocationId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getTotalItemsInBagoutCount = (bagSeal) => {
        return $http
            .get(AppConstants.api + `/bagout/get-included-bagout-count`, {
                params: {
                    bagSeal
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getRemainingBagoutList = (branchId, destinationLocationId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/bagout/get-remaining-bagout-list`, {
                params: {
                    branchId, 
                    destinationLocationId,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getTotalItemsInBagoutList = (bagSeal, offset, limit) => {
        return $http
            .get(AppConstants.api + `/bagout/get-included-bagout-list`, {
                params: {
                    bagSeal,
                    offset,
                    limit 
                }
            })
            .then((res) => {
                return res.data
            })
    };
    
    let fetchBagSeals = (searchText, startDate, endDate, limit, offset) => {
        return $http
            .get(AppConstants.api + `/bagout/fetch-bag-seals`, {
                params: {
                    searchText, startDate, endDate, limit, offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let removeTrackingIdFromBagout = (trackingId, branchId, bagSealId, fromLocationId, toLocationId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/bagout/remove-tracking-id-from-bagout`, { trackingId, branchId, bagSealId, fromLocationId, toLocationId, vaultDate })
            .then((res) => {
                return res.data
            })
    };

    let deleteBagout = (bagoutId) => {
        return $http
            .post(AppConstants.api + `/bagout/${bagoutId}/delete`, {})
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        closeBagout,
        getShipments,
        getBagsealData,
        undoBagout,
        getDeliveryRoutes,
        getBagoutData,
        exportBagoutHistory,
        getRemainingBagoutCount,
        getTotalItemsInBagoutCount,
        getRemainingBagoutList,
        getTotalItemsInBagoutList,
        fetchBagSeals,
        removeTrackingIdFromBagout,
        deleteBagout
    };
};

BagoutService.$inject = ['$http', '$q']

export default BagoutService;


// WEBPACK FOOTER //
// ./client/app/services/bagout.service.js